export default {
  desktop: {
    LiveThemeImporter: () => import(/* webpackChunkName: "playbetr-themeWrapLive" */'./LiveThemeImporter'),
  },
  mobile: {
    LiveThemeImporter: () => import(/* webpackChunkName: "playbetr-themeWrapLive" */'./LiveThemeImporter'),
  },
};
